

<div class="flex flex-col w-full p-2 md:p-8">
    <div class="flex flex-col">
        <div class="text-primary text-3xl font-extrabold">
            Welcome to Supersonic!
        </div>
        <div class="text-black pt-8">
            The below package has been pre-selected for you at the address: <b>{{lead?.Address}}</b>.
            Please confirm if this is the package you wish to purchase at this address, or change it below.
        </div>

        <hr class="my-5">
    </div>

    <div class="flex flex-row w-full items-center justify-center">
        <mat-stepper labelPosition="bottom" class="w-full" #stepper>
            <mat-step #stepOne label="Confirm Cart">
                <app-confirm-cart [dealerCode]="dealerCode" [currentPageTitle]="'pre-orders_page'" [lead]="lead" [emailToken]="emailToken" [userName]="userName" [leadRegistrationToken]="leadRegistrationToken" [passwordToken]="passwordToken"></app-confirm-cart>

                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <button
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                        [routerLink]='["/"]'
                        matStepperBack>
                        Cancel
                    </button>
                    <!-- <button
                        class="text-md"
                        mat-flat-button
                        [color]="'accent'"
                        (click)="next()"
                        mat-button>
                        Continue
                    </button> -->
                    <button
                        [disabled]="btnLoading"
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        (click)="checkout()">
                        <span *ngIf="!btnLoading" class="text-md font-bold">Continue</span>
                        <mat-progress-spinner *ngIf="btnLoading" [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                </div>
            </mat-step>
            <mat-step *ngIf="!isExistingCustomer" #stepTwo label="Create Password" >
                <app-create-password [userName]="userName" (passwordValue)="passwordEvent($event)"></app-create-password>

                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <button
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                        matStepperBack>
                        Back
                    </button>
                    <button
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        (click)="createPassword()"
                        [disabled]="disablePasswordButton">
                        <span *ngIf="!btnLoading" class="text-md font-bold">Continue</span>
                        <mat-progress-spinner *ngIf="btnLoading" [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                </div>
            </mat-step>

            <mat-step *ngIf="isExistingCustomer" #stepTwo label="Login" >

                <app-login-existing [userName]="existingUsername" [leadNumber]="existingLeadNumber" (passwordValue)="captureLoginPassword($event)"></app-login-existing>
                <!-- Alert -->
                <fuse-alert
                    class="mt-8 z-99"
                    *ngIf="showAlert"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'">
                    {{alert.message}}
                </fuse-alert>
                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <button
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                        matStepperBack>
                        Back
                    </button>
                    <button
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        (click)="existingLogin()"
                        [disabled]="loginLoading">
                        <span *ngIf="!loginLoading" class="text-md font-bold">Login</span>
                        <mat-progress-spinner *ngIf="loginLoading" [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                    </button>
                </div>
            </mat-step>

            <mat-step #stepThree label="Summary">
                <app-summary (acceptedTerms)="termsCheckedValue($event)" [lead]="lead" [center]="center" [order]="order" [addOns]="addOns" [upFrontAmount]="upFrontAmount" [monthlyAmount]="monthlyAmount" [VAT]="VAT"></app-summary>


                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <button
                        class="text-md mr-6 bg-gray-300 border border-black text-black font-bold"
                        mat-flat-button
                        mat-button
                        matStepperBack>
                        Back
                    </button>
                    <button
                        class="text-md font-bold"
                        mat-flat-button
                        [color]="'accent'"
                        mat-button
                        matStepperNext
                        [disabled]="!allTermsAccepted"
                        (click)="summaryNext()"
                        >
                        Continue
                    </button>
                </div>
            </mat-step>
            <mat-step #stepFour label="Payment">
                <app-payment
                    [dealerCode]="dealerCode"
                    [lead]="lead"
                    [monthlyAmount]="monthlyAmount"
                    [upFrontAmount]="upFrontAmount"
                    (hasPaymentMethod)="hasPaymentMethodEvent($event)"

                ></app-payment>

                <hr class="my-5">

                <div class="flex flex-row justify-end mt-6">
                    <div class="flex flex-row justify-end mt-6">
                        <button
                            class="text-md font-bold"
                            mat-flat-button
                            [color]="'accent'"
                            mat-button
                            (click)="placeOrder()"
                            [routerLink]="['/dashboard']"
                            [disabled]="!hasPaymentMethod"
                            [queryParams]="{ isOrderComplete: true }"
                            >
                                Confirm order
                        </button>
                    </div>
                </div>
            </mat-step>
        </mat-stepper>
    </div>